module.exports = __webpack_public_path__ + "img/05_Boton_Digitalizacion.f1416416.png";